<template>
  <div class="document">
    <div class="header">
      <EsHeader>
        <template #header>
          <div class="header-title">
            Notifications
          </div>
        </template>
      </EsHeader>
    </div>
    <es-loader v-if="loading" style="margin: 5rem"/>
    <es-exception
      v-else-if="loadingError"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
      margin="0"
      style="padding: 5rem"
    />
    <div v-else class="content">
      <es-form style="padding: 1.15rem 0rem">
        <template #es-form-header>
          <div class="header-container">
            <div>
              <th>
              <font-awesome-icon :icon="['fas', 'cog']" size="lg"/>
                Add System Notification
              </th>
            </div>
          </div>
        </template>
        <template #es-form>
          <table>
            <tbody>
              <tr>
                <th class="has-text-grey no-border top-padding table-header-normal">
                  Job Type
                </th>
                <td class="no-border">
                  <div class="control">
                    <input
                      class="input no-border"
                      type="text"
                      value="System"
                      aria-label="System"
                      readonly
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <th
                  class="has-text-grey no-border table-header-normal">
                  Job Trigger Type
                </th>
                <td class="no-border">
                  <div class="control">
                    <es-select
                      keyValue="code"
                      valueTpl="${description}"
                      v-on:update:values="selectedJobTrigger = $event"
                      :clear-out="true"
                      :setValues="objects"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th class="has-text-grey no-border table-header-normal">
                  Send To
                </th>
                <td class="no-border">
                  <div class="control">
                    <div class="">
                      State Super Users
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th class="has-text-grey no-border top-padding table-header-normal">
                  Additional Email
                </th>
                <td class="no-border">
                  <div class="control">
                    <input
                      class="input has-text-grey is-italic"
                      type="text"
                      maxlength="250"
                      v-model="additionalEmail"
                      :aria-label="additionalEmail || 'Additional Email'"
                      placeholder="sample@email.com"
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <th class="has-text-grey no-border top-padding table-header-normal">
                  Email Template
                </th>
                <td class="no-border">
                  <div class="control">
                    <div
                      class="
                        is-flex
                        flex-direction--column
                        flex-justify--start
                        file
                        has-name
                        is-right
                        is-fullwidth
                      "
                    >
                      <es-email-template-upload-input
                        input-id="id"
                        input-ref="inputFile"
                        @validFileExtensions="setErrors($event)"
                        :has-error-file="hasErrorFile"
                        :selected-files="files"
                      />
                      <div v-if="hasErrorFile" class="help is-danger">
                        {{ errorMsgFile }}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th class="has-text-grey no-border table-header-normal">
                  Frequency Type
                </th>
                <td class="no-border">
                  <div class="control">
                    <input
                      class="input no-border"
                      type="text"
                      value="Immediate"
                      aria-label="Immediate"
                      readonly
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <th class="has-text-grey table-header-normal last-row">
                  Severity
                </th>
                <td class="no-border">
                  <div class="control buttons has-addons">
                    <button
                      class="button button--form"
                      v-for="(option, index) in severityOptions"
                      :key="index"
                      @click.prevent="severityData = option.description"
                      :class="{ 'is-active': severityData === option.description }"
                    >
                      {{ option.description }}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </es-form>
      <div
        class="is-flex flex-justify--end flex-align--center"
        style="margin-right: 2rem; padding-bottom: 2rem"
      >
        <button
          class="button button-link has-underline"
          @click.prevent="cancelPanel()"
          style="margin-right: 1rem"
        >
          Cancel
        </button>
        <button
          class="button is-primary"
          @click.prevent="checkRequiredFields"
        >
          Add System Notification
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCog } from '@fortawesome/pro-solid-svg-icons';
import {
  faAngleDoubleLeft,
  faEdit,
} from '@fortawesome/pro-regular-svg-icons';
import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsSelect from '@/components/EsSelect.vue';
import EsEmailTemplateUploadInput from '@/components/EsEmailTemplateUploadInput.vue';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faAngleDoubleLeft,
  faEdit,
  faCog,
);

export default {
  mixins: [
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsException,
    EsForm,
    EsHeader,
    EsLoader,
    EsSelect,
    EsEmailTemplateUploadInput,
  },
  data() {
    return this.initialData();
  },
  created() {
    // axios.get('jobs/trigger-types')
    //   .then((response) => {
    //     this.triggerTypes = response.data;
    //     this.objects = this.createJobTriggerObj(this.triggerTypes);
    //   });
    this.onLoad();
    this.severityOptions = [
      {
        description: 'High',
      },
      {
        description: 'Medium',
      },
      {
        description: 'Low',
      },
    ];
    this.sendToOptions = [
      {
        description: 'State Contact Person(s)',
      },
      {
        description: 'State Super Users',
      },
    ];
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
      activeModules: 'appModules/activeModules',
      allModules: 'appModules/getAllModules',
      properties: 'propertiesModule/properties',
    }),
    formDataBody() {
      const selectedJobTriggerDescription = this.selectedJobTrigger[0].description;
      const selectedTemplateName = this.files[0].name;
      const formData = new FormData();
      formData.append('jobTriggerType', selectedJobTriggerDescription);
      formData.append('jobType', this.jobType);
      formData.append('jobLevel', '');

      formData.append('severity', this.severityData);
      formData.append('sendTo', 'State Super Users');
      formData.append('additionalEmail', this.additionalEmail);

      formData.append('template', selectedTemplateName);
      formData.append('templateContent', this.files[0]);

      formData.append('frequencyType', 'Immediate');

      if ((this.activeModule && this.activeModule.name) === 'personId') {
        formData.append('scheduleType', 'PID');
      } else if ((this.activeModule && this.activeModule.name) === 'directMatch') {
        formData.append('scheduleType', 'DM');
      } else if ((this.activeModule && this.activeModule.name) === 'locationID') {
        formData.append('scheduleType', 'LOC');
      }

      return formData;
    },
  },
  methods: {
    initialData() {
      return {
        loading: false,
        loadingError: false,
        hasErrorFile: false,
        errorMsgFile: null,

        files: [],
        jobType: 'System',
        sendToType: 'State Super Users',
        severityData: 'Medium',
        additionalEmail: '',
        selectedJobTrigger: '',
      };
    },
    async onLoad() {
      try {
        this.loading = true;
        this.loadingError = false;

        if ((this.activeModule && this.activeModule.name) === 'personId') {
          console.log('trigger pid');
          const res = await axios.get('schedules/list/pid');
          this.allSchedules = res.data;
          
          const response = await axios.get('jobs/trigger-types-pid');
          this.triggerTypes = response.data;
          this.objects = this.createJobTriggerObj(this.triggerTypes);
        } else if ((this.activeModule && this.activeModule.name) === 'directMatch') {
          console.log('trigger dm');
          const res = await axios.get('schedules/list/dm');
          this.allSchedules = res.data;
          
          const response = await axios.get('jobs/trigger-types-dm');
          this.triggerTypes = response.data;
          this.objects = this.createJobTriggerObj(this.triggerTypes);
        } else if ((this.activeModule && this.activeModule.name) === 'locationID') {
          console.log('trigger lid');
          const res = await axios.get('schedules/list/loc');
          this.allSchedules = res.data;
          
          const response = await axios.get('jobs/trigger-types-loc');
          this.triggerTypes = response.data;
          this.objects = this.createJobTriggerObj(this.triggerTypes);
        } else {
          const res = await axios.get('schedules');
          this.allSchedules = res.data;
          const response = await axios.get('jobs/trigger-types');
          this.triggerTypes = response.data;
          this.objects = this.createJobTriggerObj(this.triggerTypes);
        }
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    createJobTriggerObj(triggerTypes) {
      return triggerTypes.map((string, index) => ({
        code: index + 1,
        description: string,
      }));
    },
    async addNotification() {
      this.clearErrors();
      this.loading = true;
      this.loadingError = false;
      try {
        await axios({
          method: 'post',
          url: 'schedules',
          data: this.formDataBody,
        });
        this.$emit('addSystemNotification');
        this.showNotification('success', ['The System Notification has been added.']);
      } catch (e) {
        this.loadingError = true;
        this.showNotification('danger', ['The System Notification could not be added.']);
      } finally {
        this.loading = false;
      }
    },
    cancelPanel() {
      this.hideNotification();
      this.$emit('addSystemNotification');
      this.$emit('selectedJobTrigger');
    },
    checkRequiredFields() {
      if (this.files.length) {
        if (!this.hasErrorFile) {
          this.addNotification();
        } else {
          this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
        }
      } else {
        this.hasErrorFile = true;
        this.errorMsgFile = 'No file chosen. A File is required to Upload.';
        this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
      }
    },
    clearErrors() {
      this.hideNotification();
      this.hasErrorFile = false;
      this.errorMsgFile = null;
    },
    setErrors(value) {
      if (!value) {
        this.hasErrorFile = true;
        this.errorMsgFile = 'File extension is invalid. Valid extensions are \'.txt\' or \'.csv\' or \'.TXT\' or \'.CSV\'';
      } else {
        this.clearErrors();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  table th
    vertical-align: middle
  table td
    vertical-align: middle
    padding-left: 0
    &:first-child
      width: 30%
  .header
    display: flex
    align-items: center
  .no-border
    border: 0
  .property
    padding-left: 0
    font-size: 12px
    width: 70%
  .top-padding
    padding-top: 1rem
  .last-row
    width: 30% !important
</style>
